import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import DairyQuery from '~/QueryHooks/DairyQuery'
import Layout from '~/components/Layout'
import TypeCard from '~/components/TypeCard'

const BillingGroups: React.FC = () => {
  const { t } = useTranslation()
  const {
    isLoading: isBusyData,
    data: billingGroups,
    refetch: fetchData
  } = DairyQuery.getBillingGroupsList()

  useEffect(() => {
    fetchData()
  }, [t])

  const { rows } = billingGroups ? billingGroups : { rows: [] }

  return (
    <Layout
      title={t('Billing Groups')}
      isBusy={isBusyData}
      childContainerSize={'auto'}
      fontSizeHeader={'18px'}
      useSpinner
    >
      <TypeCard rows={rows} />
    </Layout>
  )
}
export default BillingGroups
